import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

export interface ElementWithKey {
    key: number;
    element: JSX.Element;
}

export default function ConfirmModal(props: { show: boolean, setShow: (show: boolean) => void, title: string, body: string, buttons: ElementWithKey[] }) {
    return (
        <>
            <Modal show={props.show} onHide={() => props.setShow(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>{props.title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>{props.body}</Modal.Body>
                <Modal.Footer>
                    {props.buttons.map((button) => {
                        return (
                            <div key={button.key}>
                                {button.element}
                            </div>
                        );
                    })}
                </Modal.Footer>
            </Modal>
        </>
  );
};

export const ButtonLoadingSpinner = () => {
    return (
        <div className="spinner-border spinner-border-sm text-default" role="status">
            <span className="visually-hidden">Loading...</span>
        </div>
    );
};